export default {
  // participants
  participantList: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees`,
  },
  detailParticipant: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/:id`,
  },
  logParticipant: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/:employeeId/audit`,
  },
  createParticipant: {
    method: "post",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employee`,
  },
  updateParticipant: {
    method: "put",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/:employeeID`,
  },
  actionParticipants: {
    method: "PATCH",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/action`,
  },
  checkEmailParticipants: {
    method: "post",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/check-email`,
  },
  listParticipantsByEmail: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/organizations/:organization_uuid/employees`,
  },
  activateParticipant: {
    method: "post",
    url: "/api/employee-benefit/covered/activate",
  },
  approveEditParticipant: {
    method: "post",
    url: "/api/employee-benefit/covered/approve-edit",
  },
  attachCardNumberParticipant: {
    method: "put",
    url: "/api/employee-benefit/covered/card-number",
  },
  deleteParticipant: {
    method: "delete",
    url: "/api/employee-benefit/covered",
  },
  exportParticipant: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/:id/export`,
  },
  exportBulkParticipant: {
    method: "post",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/export-bulk`,
  },
  terminateParticipant: {
    method: "post",
    url: "/api/employee-benefit/covered/terminate",
  },
  terminatePendingParticipant: {
    method: "post",
    url: "/api/employee-benefit/covered/terminate-pending",
  },
  // documents
  presignUpload: {
    method: "post",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/presign`,
  },
  bulkCovered: {
    method: "post",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employees/bulk-upload`,
  },
  bulkPolicy: {
    method: "post",
    url: "/api/employee-benefit/document/bulk-policy",
  },
  // plans
  planList: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employee-plans`,
  },
  createPlan: {
    method: "post",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employee-plan`,
  },
  updatePlan: {
    method: "put",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employee-plans/:planId`,
  },
  deletePlan: {
    method: "delete",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employee-plans/:id`,
  },
  // benefits
  benefitTypes: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/benefits`,
  },
  // organizations
  planListByOrganizationUUID: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/v1/employee-plans/list`,
  },
  organizationList: {
    method: "get",
    url: "/user/v1/v2/organizations",
  },
  entityList: {
    method: "get",
    url: "/user/v1/v2/sections",
  },
  // policies
  policyList: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/policies`,
  },
  detailPolicy: {
    method: "get",
    url: `${process.env.API_BASE_URL_Q_PLUS}/api/go-quotation/dashboard/v1/quotes/:quoteCode/policy`,
  },
  createPolicy: {
    method: "post",
    url: "/api/employee-benefit/policy",
  },
  updatePolicy: {
    method: "put",
    url: "/api/employee-benefit/policy/:id",
  },
  archivePolicy: {
    method: "post",
    url: "/api/employee-benefit/policy/:id/archive",
  },
  unarchivePolicy: {
    method: "post",
    url: "/api/employee-benefit/policy/:id/unarchive",
  },
  fetchBulkPolicyTemplate: {
    method: "get",
    url: "/api/employee-benefit/policy/bulk-template",
  },
  exportPolicy: {
    method: "post",
    url: "/api/employee-benefit/policy/export",
  },
};
